import type { GetterTree } from "vuex";
import type { DataExplorerState, Dashboard, RootState, Graph } from "@/types";

export const getters: GetterTree<DataExplorerState, RootState> = {
  getDashbords(state): Dashboard[] {
    return state.dashboards.data;
  },
  getDashbordsLoading(state): boolean {
    return state.dashboards.loading;
  },
  getDashbordsError(state): string | null {
    return state.dashboards.error;
  },
  getCurentGraph(state): Graph {
    return state.graph.data;
  },
  getCurentGraphLoading(state): boolean {
    return state.graph.loading;
  },
  getCurentGraphError(state): string | null {
    return state.graph.error;
  },

  getCurrentDashboard(state): Dashboard {
    return state.dashboard.data;
  },
  getCurrentDashboardLoading(state): boolean {
    return state.dashboard.loading;
  },
  getCurrentDashboardError(state): string | null {
    return state.dashboard.error;
  },

  getDashboardReport(state): Dashboard {
    return state.dashboardReport.data;
  },
  getDashboardReportLoading(state): boolean {
    return state.dashboardReport.loading;
  },
  getDashboardReportError(state): string | null {
    return state.dashboardReport.error;
  },

  getReportGraphs(state): any[] {
    return state.reportGraphs.data;
  },
  getReportGraphsLoading(state): boolean {
    return state.reportGraphs.loading;
  },
  getReportGraphsError(state): string | null {
    return state.reportGraphs.error;
  },
};
